// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { TypographyProps } from "@insite/mobius/Typography";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { ellipsis, mergeWithCss } from "@pace/XDL/Utilities";
import { css } from "styled-components";

const sharedTextStyles: TypographyProps = {
    variant: "p",
    size: 12,
    color: "text.main",
    weight: fontConfig.weight.bold,
    css: css`
        letter-spacing: 0;
        line-height: 14px;
        margin-bottom: 0px;
        ${ellipsis(2)}
    `,
};

export const createProductDescriptionStyles = (styles: ProductDescriptionStyles = {}) => {
    return mergeWithCss<ProductDescriptionStyles, ProductDescriptionStyles>(
        {
            productDetailLink: {
                color: "text.main",
                typographyProps: {
                    ...sharedTextStyles,
                },
                css: css`
                    width: auto;
                    max-height: 34px;
                    margin-bottom: 4px;
                    align-items: baseline;
                `,
            },
            productDetailDescription: {
                ...mergeWithCss(sharedTextStyles, {
                    css: css`
                        max-height: 34px;
                        margin-bottom: 4px;
                    `,
                }),
            },
        },
        styles,
    );
};
